module.exports = __webpack_public_path__ + "media/images/micin-uefeder-aei-f601b3f3ec81ff61876dd7e6b08479ca.png";